import React, { useEffect, useState } from "react";
import "./overviewCss.css";
import LiquidGlassButton from "components/LiquidGlassButton";
import { formatDateToDDMMYYYY, formatDateYYYY, formatDecimalToCSV, isValidDate, planDisplayNameHandler, toTitleCase } from "utlis/utils";
import PlanToggler from "components/PlanToggler";
import { PRIORITY_ORDER } from "constants";
import http from "services/httpService";
import { useNavigate } from "react-router";
import StarSvg from "../../../assets/svgs2026/starIconSvg.svg"
import GlassWrapper from "components/GlassWrapper";
import rightArrowSvg from "../../../assets/svgs2026/rightArrowSvg.svg"


const OverviewJsx = ({ cdDetail, setClaimsData }) => {
    const [plans, setPlans] = useState([])
    const [claimSummaryData, setClaimSummaryData] = useState(null)
    const [selectedPlan, setSelectedPlan] = useState("")
    const [selectedPlanObject, setSelectedPlanObject] = useState({})
    const [endorsementSummaryData, setEndorsementSummaryData] = useState(null)
    const navigate = useNavigate();

    const allProducts = JSON.parse(localStorage.getItem("products"))

    const cdBalanceNavigator = (redirectionLink) => {
        if (redirectionLink) {
            window.open(redirectionLink, "_blank")
        }
    }

    useEffect(() => {
        const planNames = Object.keys(allProducts)
        const priorityMap = new Map(PRIORITY_ORDER.map((item, index) => [item, index]));
        const sortByPriority = (items) => {
            return [...items].sort((a, b) => {
                const rankA = priorityMap.has(a) ? priorityMap.get(a) : Infinity;
                const rankB = priorityMap.has(b) ? priorityMap.get(b) : Infinity;
                return rankA - rankB;
            });
        }
        const sortedPlans = sortByPriority(planNames);
        setPlans(sortedPlans)
    }, [])

    useEffect(() => {
        if (selectedPlan) {
            let choosenPlan = allProducts[selectedPlan]
            setSelectedPlanObject(choosenPlan)
        } else {
            if (Object.keys(allProducts).length > 0) {
                if (Object.keys(allProducts).includes("health_insurance")) {
                    setSelectedPlan("health_insurance")
                } else {
                    let firstObjectKey = Object.keys(allProducts)[0]
                    setSelectedPlan(firstObjectKey)
                }
            }
        }
    }, [selectedPlan])

    const getEndorsementSummary = async (userplanId) => {

        try {
            const payload = {
                params: {
                    userplan_id: userplanId,
                },
            };
            const { data } = await http.get(
                "business/get_endorsement_summary/",
                payload
            );

            setEndorsementSummaryData(data)
        } catch (error) {
            console.log("# Error getEndorsementSummary:", error)
        }
    }

    const getClaimSummary = async () => {
        try {
            if (selectedPlan === "health_insurance") {
                const { data } = await http.get("business/get_claims_metric_summary/");
                setClaimSummaryData(data)
                setClaimsData(data)
            }
        } catch (error) {
            console.log("# Error getClaimSummary:", error)
        }
    }

    const initialAPICalls = async (currentUserPlanId) => {
        await getEndorsementSummary(currentUserPlanId)
        await getClaimSummary()
    }

    useEffect(() => {
        if (selectedPlanObject && selectedPlanObject?.userplan_data) {
            let currentUserPlanId = selectedPlanObject?.userplan_data?.userplan_id
            initialAPICalls(currentUserPlanId)
        }
    }, [selectedPlanObject])

    function formatDateRange(startDateStr, endDateStr) {
        const formatDate = (dateStr) => {
            const date = new Date(dateStr);

            // Extract short month (e.g., "Jul") and 2-digit year (e.g., "25")
            const month = date.toLocaleString("en-US", { month: "short" });
            const year = date.getFullYear().toString().slice(-2);

            return `${month} '${year}`;
        };

        return `${formatDate(startDateStr)} - ${formatDate(endDateStr)}`;
    }

    const isValueDateCheck = (inputValue) => {
      if(isValidDate(inputValue)) {
        return formatDateToDDMMYYYY(inputValue)
      } else {
        return inputValue
      }
    }

    const claimSummaryCardJSX = (claimSummaryMap) => {
        if (Object.keys(claimSummaryMap).length === 0) {
            return "-"
        } else {
            return (
                <>
                    {Object.entries(claimSummaryMap).map(([theKey, theValue]) => (
                        <div style={{ display: theValue !== null ? "flex" : "none", flexDirection: "column", gap: "2.5" }}>
                            <span className="card-actions-heading-css">
                                {theKey ? toTitleCase(theKey.replaceAll("_", " ")) : "-"}
                            </span>
                            <span className="card-actions-value-css">
                                {theValue ? isValueDateCheck(theValue) : "-"}
                            </span>
                        </div>
                    ))}
                </>
            )
        }
    }

    const quickLinksNavigationHandler = (linkObj) => {
        if (linkObj.type === "INTERNAL_ROUTE") {
            navigate(linkObj.target)
        } else if (linkObj.type === "EXTERNAL_URL") {
            window.open(linkObj.target, "_blank")
        }
    }

    const dateHandler = () => {
        let startDateValue = selectedPlanObject?.userplan_data?.subscription?.start_date
        let endDateValue = selectedPlanObject?.userplan_data?.subscription?.end_date
        if (startDateValue && endDateValue) {
            return formatDateRange(startDateValue, endDateValue)
        } else {
            return "-"
        }
    }

  const insurerLogoJsx = () => {
    if (selectedPlanObject?.userplan_data?.service_provider_logo) {
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "8.5px" }}>
          <span className="issuedByTextCss">{"ISSUED BY"}</span>
          <img
            width={"74.591px"}
            height={"47.267px"}
            src={selectedPlanObject?.userplan_data?.service_provider_logo}
            alt="insurer-logo"
          />
        </div>
      );
    }
  };

  const viewAllBtnJSX = (redirectUrl) => {
    return (
      <>
        <div className="card-view-all-button-css" onClick={() => navigate(redirectUrl)}>
          <span style={{ padding: "6px 0px 6px 12px", fontFamily: "Montserrat", fontSize: "12px", fontWeight: "500" }}>
            View All
          </span>
          <GlassWrapper className="glass-wrapper-no-width glass-xl">
            <div style={{ padding: "5px 6px 3px 6px" }}>
              <img src={rightArrowSvg} height={"10px"} width={"10px"} alt="rightArrowSvg" />
            </div>
          </GlassWrapper>
        </div>
      </>
    )
  }

  return (
    <div>
      {/* CD Balance */}
      {/* <div
          style={{
            marginBottom: "21px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <span className="overview-main-header-css">CD Balance</span>
          <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
            <img src={StarSvg} alt="StarSvg" />
            <div className="starLineCss" style={{ width: "100%" }} />
          </div>
        </div>
        <div className="cd-balance-cards-grid">
          {Object.keys(cdDetail).map((eachBalance) => (
            <>
              <div
                class="cd-balance-card"
                onClick={() =>
                  cdBalanceNavigator(
                    cdDetail[eachBalance].cd_balance_statement_url,
                  )
                }
              >
                <div class="spacing-css">
                  <div>
                    <span className="cd-balance-heading-css">
                      {cdDetail[eachBalance].service_provider_name}
                    </span>
                  </div>
                  <div className="gold-line-css" />
                </div>

                <span className="cd-balance-card-sub-heading">
                  {cdDetail[eachBalance]?.last_updated_date ? (
                    <>
                      {"as on"}{" "}
                      {formatDateToDDMMYYYY(
                        cdDetail[eachBalance]?.last_updated_date,
                      )}
                    </>
                  ) : (
                    "--"
                  )}
                </span>

                <div
                  style={{
                    marginTop: "22px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="cd-balance-card-footer">
                    ₹
                    {cdDetail[eachBalance].balance_amount
                      ? formatDecimalToCSV(cdDetail[eachBalance].balance_amount)
                      : 0}
                  </span>

                  <div
                    onClick={() =>
                      cdBalanceNavigator(
                        cdDetail[eachBalance].cd_balance_statement_url,
                      )
                    }
                  >
                    <LiquidGlassButton />
                  </div>
                </div>
              </div>
            </>
          ))}
        </div> */}

      {/* Plan Toggler */}
      <div style={{
        // marginTop: "61px"
      }}>
        <PlanToggler plans={plans} setSelectedPlan={setSelectedPlan} />
      </div>

      {/* Plan Details */}

      <div style={{ margin: plans.length > 1 ? "39px 0px 24px 0px" : "" }}>
        <span className="plan-heading-css">
          <div
            style={{
              marginBottom: "21px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span style={{ width: "fit-content", whiteSpace: "nowrap" }}>
              {planDisplayNameHandler(selectedPlan)}
            </span>

            <div
              style={{ display: "flex", width: "100%", alignItems: "center" }}
            >
              <img src={StarSvg} alt="StarSvg" />
              <div className="starLineCss" style={{ width: "100%" }} />
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              {insurerLogoJsx()}
            </div>
          </div>
        </span>
      </div>


      <div className="plan-details-wrapper-div">
        <div className="plan-detail-section">
          <span className="plan-detail-title-css">Policy Number</span>
          <span className="plan-detail-value-css">
            {selectedPlanObject?.userplan_data?.group_policy_number
              ? selectedPlanObject?.userplan_data?.group_policy_number
              : "-"}
          </span>
        </div>
        <div className="plan-detail-section">
          <span className="plan-detail-title-css">Total Employees</span>
          <span className="plan-detail-value-css">
            {selectedPlanObject?.number_of_employee
              ? selectedPlanObject?.number_of_employee
              : "0"}
          </span>
        </div>
        <div className="plan-detail-section">
          <span className="plan-detail-title-css">Total Lives</span>
          <span className="plan-detail-value-css">
            {selectedPlanObject?.no_of_lives
              ? selectedPlanObject?.no_of_lives
              : "0"}{" "}
          </span>
        </div>
        <div className="plan-detail-section">
          <span className="plan-detail-title-css">Period</span>
          <span className="plan-detail-value-css">{dateHandler()}</span>
        </div>
      </div>

      {/* Enrollments and Claim Summary Sections */}

      <div style={{ display: "flex", gap: "11px", width: "100%" }}>
        {/* Enrollments */}

        <div className="card-details-border" style={{ width: "40%" }}>
          <div className="flexSpaceBetweenFlexStart">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span className="card-details-heading-css">Enrollments</span>
              <span className="card-details-date-css">
                {endorsementSummaryData ? (
                  <>
                    {"as on"}{" "}
                    {formatDateToDDMMYYYY(
                      endorsementSummaryData.last_endorsement_date,
                    )}
                  </>
                ) : (
                  ""
                )}
              </span>
            </div>

            {viewAllBtnJSX("/v1/enrolments")}
          </div>


          <div style={{ display: "flex", gap: "87px" }}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2.5" }}
            >
              <span className="card-actions-heading-css">Addition</span>
              <span className="card-actions-value-css">
                {endorsementSummaryData
                  ? endorsementSummaryData.total_lives_added
                  : "-"}
              </span>
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2.5" }}
            >
              <span className="card-actions-heading-css">Deletions</span>
              <span className="card-actions-value-css">
                {endorsementSummaryData
                  ? endorsementSummaryData.total_lives_deleted
                  : "-"}
              </span>
            </div>
          </div>
        </div>

        {/* Claim Summary Sections */}

        {selectedPlan === "health_insurance" && (
          <>
            <div className="card-details-border" style={{ width: "60%" }}>
              <div className="flexSpaceBetweenFlexStart">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span className="card-details-heading-css">
                    Claims Summary
                  </span>
                  <span className="card-details-date-css">
                    as on{" "}
                    {formatDateToDDMMYYYY(
                      claimSummaryData?.claim_summary?.updated_at,
                    )}
                  </span>
                </div>

                {claimSummaryData !== null ? viewAllBtnJSX("/v1/claims") : ""}
              </div>

              <div
                style={{ display: "flex", gap: "60px" }}
                className="enrollment-card-css"
              >
                {/* Dyanmic Claim Summary Items */}

                {claimSummaryData && claimSummaryData.claim_summary
                  ? claimSummaryCardJSX(claimSummaryData.claim_summary)
                  : "--"}
              </div>
            </div>
          </>
        )}
      </div>

      {/* Quick Links */}

      <div style={{ marginTop: "48px", marginBottom: "24px" }}>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <span className="overview-main-header-css">Quick Links</span>
          <div
            style={{ display: "flex", width: "100%", alignItems: "center" }}
          >
            <img src={StarSvg} alt="StarSvg" />
            <div className="starLineCss" style={{ width: "100%" }} />
          </div>
        </div>
      </div>

      <div className="quick-links-grid">
        {selectedPlanObject?.userplan_data?.quick_links?.map((each_link) => (
          <div
            className="quick-links-card"
            onClick={() => quickLinksNavigationHandler(each_link)}
          >
            <span className="quick-link-heading-css">{each_link.title}</span>
            <LiquidGlassButton />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OverviewJsx;
